<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Partners
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <div class="px-4 py-5 bg-white sm:p-6 shadow-xl rounded-md">
                    <div class="flex items-center justify-end">
                        <inertia-link
                            v-if="permissions.partners.create"
                            class="rounded-md border border-transparent bg-gray-800 inline-flex items-center px-4 py-2 text-xs text-white uppercase tracking-widest font-semibold hover:bg-gray-700 transition"
                            :href="create_url">
                            Create Partner
                        </inertia-link>
                    </div>

                    <partner-list :partners="partners"/>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import {usePage} from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout';
import PartnerList from '@/Pages/Partners/PartnerList.vue';

export default {
    props: ['partners', 'create_url'],

    components: {
        PartnerList,
        AppLayout,
    },

    setup() {
        return {
            user: usePage().props.value.auth.user,
            permissions: usePage().props.value.auth.permissions,
        };
    },
};
</script>
